import Popover from '../Popover';
import {translate} from '../../utils';
import fileXmlSlashSvg from '../../../svg/fa-file-xml-slash.svg';

export function EInvoiceStatus({eInvoice}) {
    if (!eInvoice) {
        // E-invoice might not be relevant
        return null;
    }

    const hasEInvoice = eInvoice.warnings.length === 0;

    let eInvoiceContent, icon;
    if (hasEInvoice) {
        eInvoiceContent = <p className="m-0">{translate('zugferd', 'E_INVOICE_APPROVED')}</p>;
        icon = <i className="fa fa-fw fa-file-xml"/>
    } else {
        eInvoiceContent = <>
            {translate('zugferd', 'E_INVOICE_REJECTED')}:
            <ul className="list-unstyled">
                {eInvoice.warnings.map((warning, i) => <li key={i}>{warning}</li>)}
            </ul>
        </>;
        icon = <img src={fileXmlSlashSvg} className="text-muted" style={{height: '1em'}}/>;
    }

    return <Popover trigger={'hover'} content={eInvoiceContent}>{icon}</Popover>;
}
